"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _clsx = _interopRequireDefault(require("clsx"));

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _icons = require("../../assets/icons");

var _DropdownWithButton = require("./DropdownWithButton.styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DropdownWithButton = function DropdownWithButton(_ref) {
  var children = _ref.children,
      size = _ref.size,
      type = _ref.type,
      disabled = _ref.disabled,
      onClickBtn = _ref.onClickBtn,
      className = _ref.className,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "size", "type", "disabled", "onClickBtn", "className"]);
  var noBorder = !['tertiary', 'secondary'].includes(type);
  return (0, _jsxRuntime.jsxs)("div", {
    className: (0, _clsx["default"])('grui inline-flex', className),
    children: [(0, _jsxRuntime.jsx)(_Button["default"], {
      size: size,
      type: type,
      onClick: onClickBtn,
      disabled: disabled,
      css: [_DropdownWithButton.styles.mainButton, noBorder && _DropdownWithButton.styles.mainButtonWithoutBorder, process.env.NODE_ENV === "production" ? "" : ";label:DropdownWithButton;"],
      children: children
    }), (0, _jsxRuntime.jsx)("span", {
      role: "separator"
    }), (0, _jsxRuntime.jsx)(_Dropdown["default"], _objectSpread(_objectSpread({
      hasMinWidth: true,
      position: "bottom-end",
      disabled: disabled
    }, otherProps), {}, {
      children: (0, _jsxRuntime.jsx)(_Button["default"], {
        size: size,
        type: type,
        customIcon: (0, _jsxRuntime.jsx)(_icons.ChevronRight, {}),
        css: [_DropdownWithButton.styles.dropdownBtn, noBorder && _DropdownWithButton.styles.noBorder, process.env.NODE_ENV === "production" ? "" : ";label:DropdownWithButton;"]
      })
    }))]
  });
};

DropdownWithButton.propTypes = {
  className: _propTypes.string,
  onClickBtn: _propTypes.func,
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  disabled: _propTypes.bool,
  size: (0, _propTypes.oneOf)(['small', 'big']),
  type: (0, _propTypes.oneOf)(['primary', 'tertiary', 'note', 'secondary'])
};
DropdownWithButton.defaultProps = {
  className: undefined,
  onClickBtn: function onClickBtn() {},
  children: undefined,
  disabled: false,
  size: 'big',
  type: 'primary'
};
var _default = DropdownWithButton;
exports["default"] = _default;
//# sourceMappingURL=DropdownWithButton.js.map